import cn from 'classnames';
import styles from './Form.module.scss';

export const getClassNames = (className?: string) => {
  return cn(styles.form, className);
};
